<template>
  <div class="mb-3 mt-3">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('colony_edit.title') }}</h1>
      <colony-form :id="id" :apiary="apiary"></colony-form>
    </b-container>
  </div>
</template>

<script>
import ColonyForm from '../components/ColonyForm'
export default {
  name: 'ColonyEdit',
  components: { ColonyForm },
  props: ['id', 'apiary']
}
</script>

<style scoped>

</style>
